import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

export interface Country {
  code: string | null;
  name: string;
}

function toArray(items: any[] | undefined | null): items is Country[] {
  return Array.isArray(items);
}

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  countries: Country[] = [];
  private _loading = false;
  private _loaded = false;

  get loading() {
    return this._loading;
  }

  get loaded() {
    return this._loaded;
  }

  constructor(private http: HttpClient) {
    this.load();
  }

  load(): void {
    if (this._loading || this._loaded) {
      return;
    }
    this._loading = true;
    this.http
      .get<{
        items: Country[];
      }>(environment.SPRING_ENDPOINT_URL + '/v2/countries')
      .subscribe({
        next: (resp) => {
          const items = resp?.items || [];
          this._processItems(items);
          this._loaded = true;
          this._loading = false;
        },
        error: (e) => {
          console.debug('getCoreCountries failed', e);
          this._loading = false;
        },
      });
  }

  private _processItems(rawItems: any[]): void {
    const items = toArray(rawItems)
      ? [...rawItems].sort((a, b) => a.name.localeCompare(b.name))
      : [];

    this.countries.length = 0;

    items.unshift({ code: null, name: '───────────────' });

    ['CA', 'US'].forEach((code) => {
      const index = items.findIndex(
        (country: Country) => country.code === code,
      );
      if (index !== -1) {
        const [item] = items.splice(index, 1);
        items.unshift(item);
      }
    });

    this.countries.push(...items);
  }
}
